<template>
  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <div class="content container-fluid">

      <!-- Hero / Header -->
      <div class="hero card mb-4 border-0 shadow-sm">
        <div class="card-body d-flex flex-wrap align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="hero-icon mr-3">
              <i class="fa fa-calendar-check-o"></i>
            </div>
            <div>
              <h3 class="page-title mb-1">Ngày Lễ</h3>
              <div class="text-muted small">Quản lý ngày nghỉ theo khoảng thời gian, lặp hằng năm, theo phòng ban hoặc toàn công ty</div>
            </div>
          </div>
          <div class="mt-3 mt-md-0">
            <button class="btn btn-primary mr-2" @click="openAdd">
              <i class="fa fa-plus mr-1"></i> Thêm ngày lễ
            </button>
            <button class="btn btn-outline-secondary" @click="exportExcel">
              <i class="fa fa-file-excel-o mr-1"></i> Xuất Excel
            </button>
          </div>
        </div>
      </div>

      <!-- Stats -->
      <div class="row mb-4">
        <div class="col-md-4 mb-3">
          <div class="stat-card card shadow-sm">
            <div class="card-body d-flex align-items-center">
              <div class="stat-icon bg-primary-soft text-primary mr-3">
                <i class="fa fa-list-ul"></i>
              </div>
              <div>
                <div class="stat-value">{{ rows.length }}</div>
                <div class="stat-label">Tổng số ngày lễ</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-3">
          <div class="stat-card card shadow-sm">
            <div class="card-body d-flex align-items-center">
              <div class="stat-icon bg-success-soft text-success mr-3">
                <i class="fa fa-clock-o"></i>
              </div>
              <div>
                <div class="stat-value">{{ countDangHieuLuc }}</div>
                <div class="stat-label">Đang hiệu lực hôm nay</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-3">
          <div class="stat-card card shadow-sm">
            <div class="card-body d-flex align-items-center">
              <div class="stat-icon bg-warning-soft text-warning mr-3">
                <i class="fa fa-bell-o"></i>
              </div>
              <div>
                <div class="stat-value">{{ countSapDen }}</div>
                <div class="stat-label">Sắp đến (30 ngày)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Filters -->
      <div class="card mb-4 shadow-sm">
        <div class="card-body">
          <div class="form-row align-items-end">
            <div class="form-group col-md-3">
              <label class="mb-1">Năm (ưu tiên)</label>
              <select class="form-control" v-model="filters.year" @change="onYearChanged">
                <option :value="null">— Tất cả —</option>
                <option v-for="y in yearOptions" :key="y" :value="y">{{ y }}</option>
              </select>
            </div>

            <div class="form-group col-md-3">
              <label class="mb-1">Từ ngày</label>
              <input type="date" class="form-control" v-model="filters.from" @change="onRangeChanged" />
            </div>
            <div class="form-group col-md-3">
              <label class="mb-1">Đến ngày</label>
              <input type="date" class="form-control" v-model="filters.to" @change="onRangeChanged" />
            </div>

            <div class="form-group col-md-3">
              <label class="mb-1">Phòng ban (lọc hiển thị)</label>
              <select class="form-control" v-model="filters.phongBanId" @change="fetchData">
                <option :value="null">— Tất cả —</option>
                <option v-for="pb in phongBans" :key="pb.id || pb.value || pb.idPhongBan"
                        :value="pb.id || pb.value || pb.idPhongBan">
                  {{ pb.name || pb.label || pb.tenPhongBan }}
                </option>
              </select>
            </div>

            
          </div>

          
        </div>
      </div>

      <!-- Table -->
      <div class="card shadow-sm">
        <div class="table-responsive">
          <table class="table table-hover align-middle mb-0">
            <thead class="thead-light">
              <tr>
                <th style="width: 56px;">#</th>
                <th>Tiêu đề</th>
                <th class="text-nowrap">Khoảng nghỉ</th>
                <th class="text-nowrap">Lặp hằng năm</th>
                <th>Phạm vi áp dụng</th>
                <th>Ghi chú</th>
                <th class="text-right" style="width: 72px;">Hành động</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="7">
                  <div class="skeleton-row"></div>
                </td>
              </tr>
              <tr v-else-if="filteredSortedRows.length === 0">
                <td colspan="7" class="text-center text-muted py-4">Không có dữ liệu.</td>
              </tr>
              <tr v-for="(r, idx) in pagedRows" :key="r.idNgayLe || r.id" class="align-middle">
                <td class="text-muted">{{ (page * size) + idx + 1 }}</td>
                <td>
                  <div class="d-flex align-items-center">
                    <span class="font-weight-600">{{ r.tieuDe }}</span>
                    <span v-if="stat(r)==='PAST'" class="badge badge-light ml-2">Đã qua</span>
                    <span v-else-if="stat(r)==='CURRENT'" class="badge badge-success ml-2">Đang diễn ra</span>
                    <span v-else class="badge badge-info ml-2">Sắp đến</span>
                  </div>
                  <div v-if="r.lapHangNam" class="small text-muted">
                    <i class="fa fa-repeat mr-1"></i> Lặp theo năm
                    <span v-if="wraps(r)" class="ml-1 badge badge-warning-soft">Qua năm</span>
                  </div>
                </td>

                <td class="text-nowrap">
                  <div class="d-flex flex-column">
                    <div>
                      <span class="date-chip">
                        <i class="fa fa-calendar mr-1"></i>{{ fmtDate(r.tuNgay) }}
                      </span>
                      <i class="fa fa-long-arrow-right mx-2 text-muted"></i>
                      <span class="date-chip">
                        <i class="fa fa-calendar mr-1"></i>{{ fmtDate(r.denNgay) }}
                      </span>
                    </div>
                    <small class="text-muted">
                      {{ dayOfWeek(r.tuNgay) }} → {{ dayOfWeek(r.denNgay) }}
                    </small>
                  </div>
                </td>

                <td>
                  <span class="badge" :class="r.lapHangNam ? 'badge-info' : 'badge-secondary'">
                    {{ r.lapHangNam ? 'Có' : 'Không' }}
                  </span>
                </td>

                <td>
                  <span v-if="r.apDungToanCongTy" class="badge badge-primary">Toàn công ty</span>
                  <div v-else class="dept-chips">
                    <span v-for="n in deptNames(r)" :key="n" class="badge badge-outline mr-1 mb-1">{{ n }}</span>
                  </div>
                </td>

                <td class="text-truncate" style="max-width: 260px;">
                  {{ r.ghiChu || '—' }}
                </td>

                <td class="text-right">
                  <div class="btn-group btn-group-sm">
                    <button class="btn btn-link text-primary px-2" title="Sửa" @click="openEdit(r)">
                      <i class="fa fa-pencil"></i>
                    </button>
                    <button class="btn btn-link text-secondary px-2" title="Nhân đôi" @click="duplicate(r)">
                      <i class="fa fa-clone"></i>
                    </button>
                    <button class="btn btn-link text-danger px-2" title="Xóa" @click="confirmDelete(r)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <div class="card-footer d-flex align-items-center justify-content-between" v-if="filteredSortedRows.length">
          <div>Hiển thị {{ pagedRows.length }} / {{ filteredSortedRows.length }} bản ghi</div>
          <nav>
            <ul class="pagination mb-0">
              <li class="page-item" :class="{ disabled: page===0 }">
                <a class="page-link" href="#" @click.prevent="goto(page-1)">«</a>
              </li>
              <li v-for="p in pages" :key="p" class="page-item" :class="{ active: p===page }">
                <a class="page-link" href="#" @click.prevent="goto(p)">{{ p+1 }}</a>
              </li>
              <li class="page-item" :class="{ disabled: page>=totalPages-1 }">
                <a class="page-link" href="#" @click.prevent="goto(page+1)">»</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

    </div>

    <!-- Add/Edit Modal -->
    <div class="modal custom-modal fade show" v-if="modals.edit" style="display:block;" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 760px;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ form.id ? 'Sửa ngày lễ' : 'Thêm ngày lễ' }}</h5>
            <button type="button" class="close" @click="closeEdit"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitForm">
              <div class="form-row">
                <div class="form-group col-md-8">
                  <label>Tiêu đề <span class="text-danger">*</span></label>
                  <input class="form-control" v-model.trim="form.tieuDe" required />
                </div>
                <div class="form-group col-md-4">
                  <label class="mb-1">Lặp hằng năm</label><br/>
                  <label class="switch">
                    <input type="checkbox" v-model="form.lapHangNam">
                    <span class="slider round"></span>
                  </label>
                  <small class="d-block text-muted mt-1">
                    Sử dụng month-day (có thể qua năm)
                  </small>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-6">
                  <label>Từ ngày <span class="text-danger">*</span></label>
                  <input type="date" class="form-control" v-model="form.tuNgay" required />
                </div>
                <div class="form-group col-md-6">
                  <label>Đến ngày <span class="text-danger">*</span></label>
                  <input type="date" class="form-control" v-model="form.denNgay" required />
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-4">
                  <label class="mb-1">Áp dụng toàn công ty</label><br/>
                  <label class="switch">
                    <input type="checkbox" v-model="form.apDungToanCongTy">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="form-group col-md-8">
                  <label>Phòng ban áp dụng</label>
                  <multiselect
                    v-model="form.pbSelected"
                    :options="deptOptions"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :disabled="form.apDungToanCongTy"
                    placeholder="Chọn phòng ban"
                    label="label"
                    track-by="value"
                  />
                  <small class="form-text text-muted">
                    {{ form.apDungToanCongTy ? 'Đang áp dụng toàn công ty' : 'Có thể chọn nhiều phòng ban' }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label>Ghi chú</label>
                <textarea class="form-control" rows="2" v-model.trim="form.ghiChu"></textarea>
              </div>

              <div v-if="errorMsg" class="alert alert-danger py-2">{{ errorMsg }}</div>

              <div class="submit-section">
                <button type="submit" class="btn btn-primary submit-btn" :disabled="submitting">
                  {{ submitting ? 'Đang lưu...' : 'Lưu' }}
                </button>
                <button type="button" class="btn btn-outline-secondary ml-2" @click="closeEdit">Hủy</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- /Page Wrapper -->
</template>

<script>
import axios from '../api';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import Multiselect from 'vue-multiselect';

export default {
  name: 'NgayLe',
  components: { Multiselect },
  data() {
    const curYear = new Date().getFullYear();
    const years = [];
    for (let y = curYear - 2; y <= curYear + 2; y++) years.push(y);

    return {
      API: '/api/ngay-le',
      API_DEPT: '/api/phong-ban/options',

      loading: false,
      submitting: false,

      rows: [],
      phongBans: [],

      // client paging + local sort/filter
      page: 0,
      size: 10,
      sortBy: 'tuNgay',           // 'tuNgay' | 'tieuDe'
      sortDir: 'asc',             // 'asc' | 'desc'
      quickFilter: '',

      filters: {
        year: curYear,  // ưu tiên theo năm
        from: '',
        to: '',
        phongBanId: null
      },
      yearOptions: years,

      modals: { edit: false },
      form: {
        id: null,
        tieuDe: '',
        tuNgay: '',
        denNgay: '',
        lapHangNam: false,
        apDungToanCongTy: true,
        phongBanIds: [],
        pbSelected: [],
        ghiChu: ''
      },
      errorMsg: ''
    };
  },
  computed: {
    // chuẩn hóa dept options cho multiselect
    deptOptions() {
      return (this.phongBans || []).map(pb => ({
        value: pb.id || pb.value || pb.idPhongBan,
        label: pb.name || pb.label || pb.tenPhongBan
      }));
    },

    normalizedRows() {
      // chuẩn hóa để sort / filter an toàn
      return (this.rows || []).map(r => ({
        ...r,
        id: r.idNgayLe || r.id,
        _tu: this.tryDate(r.tuNgay),
        _den: this.tryDate(r.denNgay),
        _tieuDe: (r.tieuDe || '').toLowerCase()
      }));
    },

    filteredSortedRows() {
      let list = this.normalizedRows;

      // quick filter by title
      if (this.quickFilter.trim()) {
        const kw = this.quickFilter.trim().toLowerCase();
        list = list.filter(x => x._tieuDe.includes(kw));
      }

      // sort
      const dir = this.sortDir === 'asc' ? 1 : -1;
      if (this.sortBy === 'tieuDe') {
        list = list.slice().sort((a,b) => (a._tieuDe > b._tieuDe ? dir : -dir));
      } else { // tuNgay
        list = list.slice().sort((a,b) => ((a._tu || 0) > (b._tu || 0) ? dir : -dir));
      }

      return list;
    },

    totalPages() {
      return Math.max(1, Math.ceil(this.filteredSortedRows.length / this.size));
    },
    pages() {
      const max = 7;
      const total = this.totalPages;
      const cur = this.page;
      const start = Math.max(0, Math.min(cur - Math.floor(max/2), total - max));
      const end = Math.min(total, start + max);
      return Array.from({length: end - start}, (_,i)=> start + i);
    },
    pagedRows() {
      const start = this.page * this.size;
      return this.filteredSortedRows.slice(start, start + this.size);
    },

    countDangHieuLuc() {
      const today = this.onlyDate(new Date());
      return this.normalizedRows.filter(r => this.isCurrent(r, today)).length;
      },
    countSapDen() {
      const today = this.onlyDate(new Date());
      const next = this.addDays(today, 30);
      return this.normalizedRows.filter(r => this.isUpcomingRange(r, today, next)).length;
    }
  },
  mounted() {
    this.fetchPhongBans();
    this.fetchData();
  },
  methods: {
    // --------------- API ---------------
    async fetchPhongBans() {
      try {
        const res = await axios.get(this.API_DEPT);
        this.phongBans = res.data?.data || res.data || [];
      } catch (e) {
        console.error('Không tải được phòng ban (options)', e);
        this.phongBans = [];
      }
    },
    buildQueryParams() {
      const p = {};
      if (this.filters.from || this.filters.to) {
        if (this.filters.from) p.from = this.filters.from;
        if (this.filters.to) p.to = this.filters.to;
      } else if (this.filters.year) {
        p.year = this.filters.year;
      }
      if (this.filters.phongBanId) p.phongBanId = this.filters.phongBanId;
      return p;
    },
    async fetchData() {
      this.loading = true;
      try {
        const params = this.buildQueryParams();
        const res = await axios.get(this.API, { params });
        const list = res.data?.data || res.data || [];
        this.rows = Array.isArray(list) ? list : [];
        this.page = 0;
      } catch (e) {
        console.error('Lỗi tải danh sách ngày lễ', e);
        this.rows = [];
        Swal.fire('Lỗi', e?.response?.data?.message || 'Không thể tải dữ liệu', 'error');
      } finally {
        this.loading = false;
      }
    },

    // --------------- Filters / Sort ---------------
    resetFilters() {
      const y = new Date().getFullYear();
      this.filters.year = y;
      this.filters.from = '';
      this.filters.to = '';
      this.filters.phongBanId = null;
      this.quickFilter = '';
      this.sortBy = 'tuNgay';
      this.sortDir = 'asc';
      this.fetchData();
    },
    onYearChanged() {
      if (this.filters.year) {
        this.filters.from = '';
        this.filters.to = '';
      }
      this.fetchData();
    },
    onRangeChanged() {
      if (this.filters.from || this.filters.to) {
        this.filters.year = null;
      }
      this.fetchData();
    },
    changeSort(field) {
      if (this.sortBy === field) {
        this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortBy = field;
        this.sortDir = 'asc';
      }
    },
    goto(p) {
      if (p < 0 || p > this.totalPages - 1) return;
      this.page = p;
    },

    // --------------- Helpers (date / status) ---------------
    fmtDate(d) {
      if (!d) return '—';
      const dt = this.tryDate(d);
      if (!dt) return d;
      return dt.toLocaleDateString('vi-VN', { day:'2-digit', month:'2-digit', year:'numeric' });
    },
    dayOfWeek(d) {
      const dt = this.tryDate(d);
      if (!dt) return '';
      return dt.toLocaleDateString('vi-VN', { weekday:'long' });
    },
    tryDate(d) {
      if (!d) return null;
      const t = new Date(d);
      if (!isNaN(t.getTime())) return t;
      // nếu BE trả yyyy-MM-dd, Date vẫn parse OK; nếu không, trả null
      return null;
    },
    onlyDate(dt) {
      const d = new Date(dt);
      d.setHours(0,0,0,0);
      return d;
    },
    addDays(d, n) {
      const x = new Date(d);
      x.setDate(x.getDate()+n);
      x.setHours(0,0,0,0);
      return x;
    },
    md(dt) {
      return { m: dt.getMonth()+1, d: dt.getDate() };
    },
    wraps(r) {
      // với lặp năm: xác định khoảng có qua năm hay không
      if (!r.lapHangNam) return false;
      const a = this.tryDate(r.tuNgay), b = this.tryDate(r.denNgay);
      if (!a || !b) return false;
      const ma = this.md(a), mb = this.md(b);
      if (ma.m > mb.m) return true;
      if (ma.m < mb.m) return false;
      return ma.d > mb.d;
    },
    containsDate(r, date) {
      // logic tương tự BE: xét lặp năm
      const a = this.tryDate(r.tuNgay), b = this.tryDate(r.denNgay);
      if (!a || !b) return false;
      const d = this.onlyDate(date);

      if (!r.lapHangNam) {
        return !(this.onlyDate(b) < d || this.onlyDate(a) > d) && (d >= this.onlyDate(a) && d <= this.onlyDate(b));
      }
      const ma = this.md(a), mb = this.md(b), md = this.md(d);
      const wrap = this.wraps(r);
      if (!wrap) {
        if (md.m < ma.m || md.m > mb.m) return false;
        if (md.m === ma.m && md.d < ma.d) return false;
        if (md.m === mb.m && md.d > mb.d) return false;
        return true;
      } else {
        // qua năm: hợp lệ nếu md >= start (cuối năm) hoặc md <= end (đầu năm)
        const afterStart = (md.m > ma.m) || (md.m === ma.m && md.d >= ma.d);
        const beforeEnd  = (md.m < mb.m) || (md.m === mb.m && md.d <= mb.d);
        return afterStart || beforeEnd;
      }
    },
    isCurrent(r, today = this.onlyDate(new Date())) {
      return this.containsDate(r, today);
    },
    isUpcomingRange(r, from, to) {
      // sắp đến trong 30 ngày tới (đơn giản: ngày bắt đầu nằm trong (from, to])
      const a = this.tryDate(r.tuNgay);
      if (!a) return false;
      const aa = this.onlyDate(a);
      return aa > from && aa <= to;
    },
    stat(r) {
      const today = this.onlyDate(new Date());
      if (this.isCurrent(r, today)) return 'CURRENT';
      const tu = this.tryDate(r.tuNgay);
      if (tu && this.onlyDate(tu) > today) return 'UPCOMING';
      return 'PAST';
    },
    deptNames(r) {
      if (Array.isArray(r.phongBanNames) && r.phongBanNames.length) return r.phongBanNames;
      if (Array.isArray(r.phongBans)) return r.phongBans.map(x => x.tenPhongBan || x.name);
      return [];
    },

    // --------------- CRUD ---------------
    openAdd() {
      this.errorMsg = '';
      this.form = {
        id: null,
        tieuDe: '',
        tuNgay: '',
        denNgay: '',
        lapHangNam: false,
        apDungToanCongTy: true,
        phongBanIds: [],
        pbSelected: [],
        ghiChu: ''
      };
      this.modals.edit = true;
    },
    openEdit(row) {
      this.errorMsg = '';
      const ids = row.phongBanIds || [];
      const pbSelected = this.deptOptions.filter(x => ids.includes(x.value));
      this.form = {
        id: row.idNgayLe || row.id,
        tieuDe: row.tieuDe || '',
        tuNgay: this.bindDate(row.tuNgay),
        denNgay: this.bindDate(row.denNgay),
        lapHangNam: !!row.lapHangNam,
        apDungToanCongTy: !!row.apDungToanCongTy,
        phongBanIds: ids,
        pbSelected,
        ghiChu: row.ghiChu || ''
      };
      this.modals.edit = true;
    },
    closeEdit() {
      this.modals.edit = false;
    },
    bindDate(d) {
      if (!d) return '';
      const t = this.tryDate(d);
      if (!t) return d;
      const yyyy = t.getFullYear();
      const mm = (`0${t.getMonth()+1}`).slice(-2);
      const dd = (`0${t.getDate()}`).slice(-2);
      return `${yyyy}-${mm}-${dd}`;
    },
    validateForm() {
      if (!this.form.tieuDe?.trim()) return 'Vui lòng nhập tiêu đề.';
      if (!this.form.tuNgay || !this.form.denNgay) return 'Vui lòng chọn khoảng ngày.';
      if (this.form.denNgay < this.form.tuNgay) return 'Đến ngày phải ≥ Từ ngày.';
      if (!this.form.apDungToanCongTy && (!this.form.pbSelected || this.form.pbSelected.length===0)) {
        return 'Chọn ít nhất một phòng ban hoặc bật áp dụng toàn công ty.';
      }
      return '';
    },
    async submitForm() {
      this.errorMsg = this.validateForm();
      if (this.errorMsg) return;

      this.submitting = true;
      try {
        const phongBanIds = this.form.apDungToanCongTy ? [] : (this.form.pbSelected || []).map(x => x.value);
        const payload = {
          tieuDe: this.form.tieuDe,
          tuNgay: this.form.tuNgay,
          denNgay: this.form.denNgay,
          lapHangNam: this.form.lapHangNam,
          apDungToanCongTy: this.form.apDungToanCongTy,
          phongBanIds,
          ghiChu: this.form.ghiChu
        };

        if (this.form.id) {
          await axios.put(`${this.API}/${this.form.id}`, payload);
          Swal.fire('Thành công', 'Cập nhật ngày lễ thành công', 'success');
        } else {
          await axios.post(this.API, payload);
          Swal.fire('Thành công', 'Tạo ngày lễ thành công', 'success');
        }
        this.modals.edit = false;
        this.fetchData();
      } catch (e) {
        console.error('Lỗi lưu ngày lễ', e);
        this.errorMsg = e?.response?.data?.message || 'Lưu thất bại. Vui lòng thử lại.';
      } finally {
        this.submitting = false;
      }
    },
    duplicate(row) {
      // mở form với dữ liệu sẵn, xóa id
      const ids = row.phongBanIds || [];
      const pbSelected = this.deptOptions.filter(x => ids.includes(x.value));
      this.form = {
        id: null,
        tieuDe: (row.tieuDe || '') + ' (bản sao)',
        tuNgay: this.bindDate(row.tuNgay),
        denNgay: this.bindDate(row.denNgay),
        lapHangNam: !!row.lapHangNam,
        apDungToanCongTy: !!row.apDungToanCongTy,
        phongBanIds: ids,
        pbSelected,
        ghiChu: row.ghiChu || ''
      };
      this.modals.edit = true;
    },
    async confirmDelete(row) {
      const id = row.idNgayLe || row.id;
      if (!id) return;
      const ret = await Swal.fire({
        title: 'Xóa ngày lễ?',
        html: `Bạn chắc chắn muốn xóa <b>${row.tieuDe || ''}</b>?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Hủy',
        confirmButtonColor: '#e74c3c'
      });
      if (!ret.isConfirmed) return;

      try {
        await axios.delete(`${this.API}/${id}`);
        Swal.fire('Đã xóa', 'Bản ghi đã được xóa', 'success');
        this.fetchData();
      } catch (e) {
        console.error('Xóa thất bại', e);
        Swal.fire('Lỗi', e?.response?.data?.message || 'Không thể xóa bản ghi này.', 'error');
      }
    },

    // --------------- Export ---------------
    exportExcel() {
      if (!this.filteredSortedRows.length) {
        Swal.fire('Thông báo', 'Không có dữ liệu để xuất.', 'info');
        return;
      }
      const data = this.filteredSortedRows.map((r, i) => ({
        STT: i + 1,
        'Tiêu đề': r.tieuDe,
        'Từ ngày': this.fmtDate(r.tuNgay),
        'Đến ngày': this.fmtDate(r.denNgay),
        'Lặp hằng năm': r.lapHangNam ? 'Có' : 'Không',
        'Phạm vi': r.apDungToanCongTy ? 'Toàn công ty' : this.deptNames(r).join(', '),
        'Ghi chú': r.ghiChu || ''
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'NgayLe');
      XLSX.writeFile(wb, 'ngay-le.xlsx');
    }
  }
};
</script>

<style scoped>
/* Hero */
.hero {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 70%);
}
.hero-icon {
  width: 48px; height: 48px;
  border-radius: 12px;
  background: #f0f4ff;
  color: #3b82f6;
  display: flex; align-items: center; justify-content: center;
  font-size: 22px;
}

/* Stat cards */
.stat-card .stat-icon {
  width: 44px; height: 44px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 18px;
}
.bg-primary-soft { background: rgba(59,130,246,.12); }
.bg-success-soft { background: rgba(34,197,94,.12); }
.bg-warning-soft { background: rgba(245,158,11,.12); }
.badge-warning-soft {
  color: #b7791f; background: rgba(245,158,11,.15); border: 1px solid rgba(245,158,11,.25);
}
.stat-value { font-size: 22px; font-weight: 700; line-height: 1; }
.stat-label { font-size: 12px; color: #6c757d; }

/* Date chips */
.date-chip {
  display: inline-flex; align-items: center;
  border: 1px dashed #cfd8dc; padding: 4px 8px; border-radius: 8px;
  background: #fff;
}

/* Dept chips */
.badge-outline {
  border: 1px solid #ced4da;
  color: #495057;
  background: #fff;
}
.dept-chips .badge-outline { font-weight: 500; }

/* Toggle switch */
.switch { position: relative; display: inline-block; width: 46px; height: 24px; }
.switch input { display:none; }
.slider { position: absolute; cursor: pointer; inset: 0; background: #cfd8dc; transition: .2s; border-radius: 24px; }

input:checked + .slider { background-color: #36bea6; }
input:checked + .slider:before { transform: translateX(22px); }

/* Skeleton */
.skeleton-row {
  height: 56px;
  background: linear-gradient(90deg, rgba(0,0,0,.04), rgba(0,0,0,.08), rgba(0,0,0,.04));
  background-size: 600% 600%;
  animation: shimmer 1.2s ease infinite;
  border-radius: 8px;
}
@keyframes shimmer {
  0% { background-position: 0% 50%; }
  100% { background-position: 100% 50%; }
}

/* Buttons in actions */
.btn-link { text-decoration: none; }
.btn-link:hover { opacity: .75; }
.table td, .table th { vertical-align: middle; }

/* vue-multiselect tweaks */
.multiselect {
  --shadow-color: rgba(0, 0, 0, .05);
  box-shadow: 0 1px 2px var(--shadow-color);
  border-radius: .5rem;
}
.modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    display: none;
    width: 100%;
    height: 100%;
    overflow: hidden;
    outline: 0;
    background-color: #00000021;
}
</style>
